// extracted by mini-css-extract-plugin
export default {"labelPlain":"SelectSingleFilter_labelPlain__fChwo","labelPlainSelected":"SelectSingleFilter_labelPlainSelected__aGQyC","popupSize":"SelectSingleFilter_popupSize__83uu7"};